let colourName = ["Blue", "Pink", "Orange", "Purple"];
let colour = ["Blue", "Pink", "Orange", "Purple"];
let buttons = ["Blue", "Pink", "Orange", "Purple"]

const shuffle = (array) => {

    let currentIndex = array.length;
    let temporaryValue, randomIndex;

    while (0 !== currentIndex) {
        randomIndex = Math.floor(Math.random() * currentIndex);
        currentIndex -= 1;

        temporaryValue = array[currentIndex];
        array[currentIndex] = array[randomIndex];
        array[randomIndex] = temporaryValue;
    }

    return array;

};

export { shuffle, colourName, colour, buttons }